import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import {Info, Clock, Calendar, X} from 'preact-feather';

import style from './style';

class InfoModal extends Component {
	open = () => this.setState({ open:true });
	close = () => this.setState({ open:false });
	  

	render({}, {open}) {
		return (
			<div class="pull-right">
				<button onClick={this.open}>
					<Info />
				</button>
			
				{ open ? (
					<div class={style.info}>
						<div className="wrapper">
							<h2><Info /> Intercesión</h2>
							<button type button class="button secondary">
								<X onClick={this.close} />
							</button>


							<div className="info-content">
						
								<h4>Verano 2019</h4>
								<p>
									Este verano vamos a dar inicio a una nueva estrategia de intercesión para Iglesia Norte, ya que
									pensamos que necesitamos que se involucren más personas en la intercesión de la Iglesia. Hasta
									ahora hemos sido un grupo bastante fiel y constante que ha llevado sobre sus hombros la carga
									de la oración e intercesión en la iglesia.
									Ahora es el momento de que la iglesia entera tome su responsabilidad y comencemos nuestro
									proceso de convirtamos en verdaderos intercesores.
								</p>
								<p>
									Vamos a seguir orando por los mismos puntos que hasta ahora, pero vamos a repartir los puntos de oración en 4 días.
								</p>

								<h4>Oración de Lunes a Jueves.</h4>

								<small><Calendar /> Lunes - Jueves</small>
								<small><Clock /> 10 min</small>
								<ul>
									<li>Se repartirán estos días por células, así que a cada célula le corresponderá orar un día especifico.</li>
									<li>Se ora en casa.</li>
									<li>La oración será de 10 minutos.</li>
									<li>Hay tres horarios a los que unirse en oración: 22:00, 23:00 y 00:00.</li>
									<li>Cada persona escoge el horario que mejor le convenga.</li>
									<li>Cuando se haya terminado de orar, se le comunica al líder de célula.</li>
									<li>El líder de célula comunicará el número de personas que han orado ese día a la persona asignada del departamento del Ganar que recogerá los datos.</li>
									<li>EL recuento es para saber si la iglesia está realmente intercediendo por todas los puntos, y si no, poder remediarlo.</li>
									<li>Los puntos a orar se repartirán por días: Ej: Lunes: Oramos por Pastores, Liderazgo y Familias.</li>
									<li>Los puntos a orar irán rotando cada mes. De esta manera a las células les tocará orar por diferentes puntos cada mes.</li>
								</ul>

								<h4>Montaña de Oración</h4>

								<small><Calendar /> Viernes</small>
								<small><Clock /> 20:00 - 21:00</small>
								<ul>
									<li>Todos los Viernes de 20:00-21:00 oraremos juntos en la Iglesia.</li>
									<li>Habrá dos alabanzas, se compartirá una Palabra Rema y habrá Intercesión por todos los puntos que oramos.</li>
									<li>Se responsabilizarán de las montañas de oración los equipos de 12 de los Pastores.</li>
									<li>3 Parejas de los equipos de 12 irán rotando semana a semana.</li>
									<li>Serán responsables de toda la reunión.</li>
									<li>Preparar un equipo técnico que pueda encender pantallas y llevar el sonido.</li>
									<li>Dos alabanzas con pista.</li>
									<li>Una palabra Rema de 5 minutos.</li>
									<li>Orarán por los 12 puntos, repartiéndose los puntos 2 por cada uno de los líderes.</li>
								</ul>
							</div>
						</div>
					</div>
				): null}
			</div>
		)
	}
}

export default InfoModal;



// WEBPACK FOOTER //
// ./components/info/index.js